/** Components ----------------------------------------------------------- */
import { createTheme } from "@mui/material/styles";

/* Theme settings */
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 300,
            sm: 600,
            md: 1280,
            lg: 1680,
            xl: 2560,
        },
    },
    mixins: {
        toolbar: {
            minHeight: 50,
        },
    },
    palette: {
        primary: {
            main: "#361A52",
        },
        secondary: {
            main: "#ED1556",
        },
        text: {
            primary: "#4D3365",
        },
        error: {
            main: "#EF4277",
        },
        "V100": "#20003f",
        "V090": "#361a52",
        "V080": "#4d3365",
        "V070": "#634d79",
        "V060": "#79568c",
        "V050": "#8f809f",
        "V040": "#a699b2",
        "V030": "#bcb3c5",
        "V020": "#d2ccd9",
        "V010": "#e9e6ec",
        "V003": "#f8f7f9",
        "C100": "#ed1556",
        "C090": "#EE2C66",
        "C080": "#EF4277",
        "C070": "#F05987",
        "C060": "#F26F97",
        "C050": "#F286A7",
        "C040": "#F8A1BB",
        "C030": "#FAB9CC",
        "C020": "#FBD0DD",
        "C010": "#FDE8EE",
        "C003": "#FEF8FA",
        "P100": "#3B237B",
        "P020": "#D8D3E5",
        "G100": "#9470EE",
        "G020": "#DCCFFF",
        "A100": "#33B1FF",
        "A020": "#B8E4FF",
        "E100": "#47F3C5",
        "E020": "#D8F5EE",
        "CIT100": "#FFFF9E",
        "CIT020": "#FFF5E3",
        "H100": "#427878",
        "H020": "#ccd5d4",
        "O100": "#ff966b",
        "O020": "#ffdbc6",
        "B100": "#f35dab",
        "B020": "#f9cddd",
        "D100": "#caef70",
        "D020": "#e6f7c0",
        "S100": "#90d2ff",
        "S020": "#d7edff",
        "N012": "#E0E0E0",
        "N038": "#9E9E9E",
        "N050": "#666666",
        "N400": "#BDBDBD",
    },
    typography: {
        htmlFontSize: 16,
        fontSize: 16,
        fontFamily: "Gantari, sans-serif",
        fontWeightLight: 400,
        fontWeightRegular: 600,
        fontWeightBold: 700,
        h1: {
            fontWeight: 600,
            fontSize: 32,
        },
        h2: {
            fontWeight: 400,
            fontSize: 24,
        },
        h3: {
            fontWeight: 600,
            fontSize: 18,
        },
        subtitle1: {
            fontWeight: 600,
            fontSize: 16,
        },
        subtitle2: {
            fontWeight: 600,
            fontSize: 25,
        },
        body1: {
            fontWeight: 400,
            fontSize: 14,
        },
        body2: {
            fontWeight: 400,
            fontSize: 16,
        },
        button: {
            fontWeight: 600,
            fontSize: 14,
            textTransform: "none",
        },
    },
    default: {
        borderRadius: "6px",
        height: "42px"
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                },
            },
        },
    },
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: "#4a22d4",
                "& button:hover": {
                    backgroundColor: "#927ae5",
                },
            },
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                "& span": {
                    color: "#4a22d4",
                },
                "& p": {
                    fontWeight: "600",
                    color: "#4a22d4",
                    fontSize: 14,
                },
            },
            daysHeader: {
                "& span": {
                    fontWeight: "600",
                    color: "#927ae5",
                    fontSize: 10,
                },
            },
        },
        MuiPickersDay: {
            day: {
                color: "#131f3e",
                "& p": {
                    fontWeight: "600",
                    fontSize: 14,
                },
            },
            daySelected: {
                color: "#131f3e",
                backgroundColor: "#e4def9",
                "&:hover": {
                    backgroundColor: "#e4def9",
                },
            },
            current: {
                color: "#4a22d4",
            },
        },
    },
});

export default theme;
